import { useAuthUser } from "../hooks/useAuthUser";
import type { WosRole } from "../types/auth";
import type { ReactNode } from "react";

export interface RequireRoleProps {
  /** Renderiza children se o usuário tem PELO MENOS UMA destas roles. */
  anyOf: WosRole[];
  /** Conteúdo alternativo se role ausente (default: nada). */
  fallback?: ReactNode;
  children: ReactNode;
}

/**
 * Componente declarativo para esconder elementos baseado em roles.
 *
 * <RequireRole anyOf={["platform-admin", "platform-operations"]}>
 *   <Button>Disparar saga</Button>
 * </RequireRole>
 *
 * Usar em pages que já estão sob `<RequireAuth>` (logo, sempre há usuário).
 */
export function RequireRole({ anyOf, fallback = null, children }: RequireRoleProps) {
  const { hasAnyRole } = useAuthUser();
  if (!hasAnyRole(...anyOf)) return <>{fallback}</>;
  return <>{children}</>;
}
